export default __webpack_public_path__ + "fbf4d3a825e20ce7134c4f2c5e2c3769.svg";